import { QueryFields } from "@directus/sdk";
import {
  fetchPropAvailability,
  fetchProps,
  fetchPropsTransaction,
  fetchTransactionAggregate,
} from "../api/props";
import { GaripalliDirectusClient } from "../directus/client";
import { Props } from "../directus/collections";
import { Schema } from "../directus/schema";

export async function getPropsByIds(
  client: GaripalliDirectusClient,
  { propsIds }: { propsIds: string | string[] }
): Promise<Props[]> {
  if (!propsIds.length) {
    return [];
  }

  propsIds = !Array.isArray(propsIds) ? [propsIds] : propsIds;

  const cityEscapeProps = await fetchProps(client, {
    filter: { id: { _in: propsIds } },
    fields: [
      "*",
      "translations.*",
      "partners.*",
      "partners.translations.*",
      "media.*",
    ] as QueryFields<Schema, Props>,
  });
  return cityEscapeProps;
}

export async function getPropsTransactions(
  client: GaripalliDirectusClient,
  { propId, partnerId }: { propId: string; partnerId?: string }
) {
  const propsTransactions = await fetchPropsTransaction(client, {
    filter: {
      props: { _eq: propId },
    },
    fields: ["*"] as QueryFields<Schema, Props>,
  });
  return propsTransactions;
}

export async function getTotalDeliveredAmount(
  client: GaripalliDirectusClient,
  propId: string
): Promise<number> {
  const transactions = await fetchTransactionAggregate<
    { sum: { amount: number } }[]
  >(client, {
    aggregate: {
      sum: "amount",
    },
    query: {
      filter: {
        props: { _eq: propId },
        amount: { _gt: 0 },
      },
    },
    groupBy: ["props"],
  });

  return transactions[0].sum.amount;
}

export async function getTotalWithdrawAmount(
  client: GaripalliDirectusClient,
  propId: string
): Promise<number> {
  const transactions = await fetchTransactionAggregate<
    { sum: { amount: number } }[]
  >(client, {
    aggregate: {
      sum: "amount",
    },
    query: {
      filter: {
        props: { _eq: propId },
        amount: { _lt: 0 },
      },
    },
    groupBy: ["props"],
  });

  return transactions[0].sum.amount;
}

export async function getPropAvailability(
  directus: GaripalliDirectusClient,
  id: string
): Promise<{ status: string; available: boolean }> {
  const result = await fetchPropAvailability(directus, id);
  return result;
}
